module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_vm._v("The American Practical Navigator,"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(" first published in 1802 by Nathaniel Bowditch, is an encyclopedia of navigation. It serves as a valuable handbook on oceanography and meteorology, and contains useful tables and a maritime glossary. In 1867 the copyright and plates were bought by the Hydrographic Office of the United States Navy, and as a U.S. Government publication. The text has evolved with the advances in navigation practices since that first issue and continues to serve as a valuable reference for marine navigation in the modern day. It is considered one of America’s nautical institutions.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0